import { render, staticRenderFns } from "./Domains.vue?vue&type=template&id=f42e142a"
import script from "./Domains.vue?vue&type=script&lang=js"
export * from "./Domains.vue?vue&type=script&lang=js"
import style0 from "./Domains.vue?vue&type=style&index=0&id=f42e142a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports